/**
 * Labelled text input with inline error display.
 * Wraps a native <input> with consistent DecidA styling.
 */
export default function InputField({
  label,
  id,
  error,
  className = '',
  required = false,
  ...props
}) {
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {label && (
        <label htmlFor={id} className="text-sm font-semibold text-brand-dark">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      <input
        id={id}
        className={`form-field ${error ? 'form-field-error' : ''}`}
        {...props}
      />
      {error && (
        <p className="text-xs text-red-500 font-medium mt-0.5">{error}</p>
      )}
    </div>
  )
}
